_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[80],{

/***/ "LeDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__N_SSP", function() { return __N_SSP; });
/* harmony import */ var _src_client_views_dynamic_page_DynamicPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rZXT");

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (_src_client_views_dynamic_page_DynamicPage__WEBPACK_IMPORTED_MODULE_0__[/* DynamicPage */ "a"]);

/***/ }),

/***/ "XL2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BaiduSeoScript_BaiduSeoScript; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/media-server/index.js
var media_server = __webpack_require__("FLQK");

// CONCATENATED MODULE: ./src/seo/json-ld/index.js



function getBaiduStructuredPageData(title, description, imageUrls, pageUrl) {
  return {
    '@context': 'https://zhanzhang.baidu.com/contexts/cambrian.jsonld',
    '@id': pageUrl,
    title: title,
    description: description,
    images: imageUrls.map(function (url) {
      return media_server["a" /* getUrl */]({
        format: '_AUTOFORMAT_',
        url: url,
        width: 2000,
        height: 'auto',
        transform: 'resize',
        quality: 70
      });
    }),
    pubDate: moment_default()() // Set to the beginning of the current quarter,
    // 1st day of months, 12:00 am
    .startOf('quarter').format('YYYY-MM-DDThh:mm:ss')
  };
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/seo/sitemap/sitemap.utils.js


















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var SITEMAP_URL_CHANGE_FREQUENCY = 'weekly';
var SITEMAP_URL_PRIORITY = 0.5;
var XML_NAMESPACES = ['xmlns="https://www.sitemaps.org/schemas/sitemap/0.9"', 'xmlns:xhtml="https://www.w3.org/1999/xhtml"'];
function isBaiduBot() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // Detects Baidu’s web crawler via the user agent string.
  // e.g. "Mozilla/5.0 (compatible; Baiduspider/2.0; +http://www.baidu.com/search/spider.html)"

  return new RegExp('Baiduspider', 'ig').test(userAgent);
}
function getXmlNamespaces(userAgent) {
  var xmlNamespaces = isBaiduBot(userAgent) ? [].concat(XML_NAMESPACES, ['xmlns:mobile="https://www.baidu.com/schemas/sitemap-mobile/1/"']) : XML_NAMESPACES;
  return xmlNamespaces.join(' ');
}
function getPageUrls(_x, _x2) {
  return _getPageUrls.apply(this, arguments);
}

function _getPageUrls() {
  _getPageUrls = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(pageTypes, appContext) {
    var pageTypesString, pagesQuery, _yield$graphQLClient$, pages;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageTypesString = pageTypes.map(function (pageType) {
              return "\"".concat(pageType, "\"");
            }).join(',');
            pagesQuery = "{\n    pages: pagesByTypes(pageTypes: [".concat(pageTypesString, "]) {\n      href: url\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(pagesQuery, appContext, {
              requestName: requestDictionary["tc" /* PAGE_SITEMAP */]
            });

          case 5:
            _yield$graphQLClient$ = _context.sent;
            pages = _yield$graphQLClient$.pages;
            return _context.abrupt("return", pages);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            logger_default.a.error(_context.t0);
            return _context.abrupt("return", []);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _getPageUrls.apply(this, arguments);
}

function getPageEntries(dataEntries, _ref) {
  var locale = _ref.locale,
      originalUrl = _ref.originalUrl,
      userAgent = _ref.userAgent;
  var uri = new URI_default.a(originalUrl);
  var hostname = uri.hostname();
  var tld = uri.tld();
  var isDomainDefaultLocale = dist_default.a.getLocaleFromHostname(tld) === locale;
  return dataEntries.map(function (_ref2) {
    var href = _ref2.href; // Build full entry url

    var entryUri = new URI_default.a(href).protocol('https').hostname(hostname).tld(tld);

    if (!isDomainDefaultLocale && locale) {
      entryUri.addQuery({
        locale: locale
      });
    } // Build complete entry


    return _objectSpread({
      url: entryUri.toString(),
      changefreq: SITEMAP_URL_CHANGE_FREQUENCY,
      priority: SITEMAP_URL_PRIORITY
    }, isBaiduBot(userAgent) && {
      mobile: 'pc mobile'
    });
  });
}
function getHreflangs(_x3) {
  return _getHreflangs.apply(this, arguments);
}

function _getHreflangs() {
  _getHreflangs = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(appContext) {
    var query, _yield$graphQLClient$2, hreflangs;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = "{\n  hreflangs {\n    url\n    links {\n      url\n      lang\n    }\n  }\n}";
            _context2.prev = 1;
            _context2.next = 4;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: Object(requestDictionary["rd" /* getGqlName */])(['CMS', 'HREFLANGS'])
            });

          case 4:
            _yield$graphQLClient$2 = _context2.sent;
            hreflangs = _yield$graphQLClient$2.hreflangs;
            return _context2.abrupt("return", hreflangs);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            logger_default.a.error(_context2.t0);
            return _context2.abrupt("return", []);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return _getHreflangs.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// CONCATENATED MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx






var __jsx = react_default.a.createElement;





var BaiduSeoScript_BaiduSeoScript = function BaiduSeoScript(_ref) {
  var lines = _ref.lines,
      locale = _ref.locale,
      userAgent = _ref.userAgent,
      originalUrl = _ref.originalUrl,
      pageTitle = _ref.pageTitle,
      pageDescription = _ref.pageDescription;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var getImmersives = function getImmersives(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media;

      var backgroundURL = isDesktop ? line.props.backgroundURLDesktop : line.props.backgroundURLMobile;
      immersives = line.name === 'immersive' ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), [backgroundURL]) : immersives;
      immersives = line.name === 'product-immersive' && !!((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos) ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), Object(toConsumableArray["a" /* default */])(line.props.media.photos.map(function (p) {
        return p.url;
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives;
  };

  return isBaiduBot(userAgent) && Object(localeUtils["a" /* isChineseLocale */])(locale) && __jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(getBaiduStructuredPageData(pageTitle, pageDescription, getImmersives(lines), originalUrl))
    }
  });
};

/***/ }),

/***/ "rZXT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicPage; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("vpUC");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("EkOT");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ub5k");
/* harmony import */ var _components_seo_FacebookAndTwitterSeoHeaderMeta__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("LaX8");
/* harmony import */ var _components_third_party_BaiduSeoScript__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("XL2j");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("nv//");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_16__);







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;










var Line = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function () {
  return __webpack_require__.e(/* import() */ 21).then(__webpack_require__.bind(null, "ybtA")).then(function (m) {
    return m.Line;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ybtA")];
    },
    modules: ["../../components/frameworks/line/Line"]
  }
});
var DynamicPage = function DynamicPage(_ref) {
  var noindex = _ref.noindex,
      page = _ref.page;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_10__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__[/* useAppContext */ "c"])(),
      userAgent = _useAppContext.userAgent,
      originalUrl = _useAppContext.originalUrl,
      locale = _useAppContext.locale;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_11__[/* usePageContext */ "b"])(),
      canonicalUrl = _usePageContext.canonicalUrl,
      pageDescription = _usePageContext.pageDescription,
      pageTitle = _usePageContext.pageTitle,
      pageType = _usePageContext.pageType;

  var origin = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_15__[/* convertUrlToOrigin */ "c"])(originalUrl);
  var currentUri = origin + asPath;
  var canonicalURI = new urijs__WEBPACK_IMPORTED_MODULE_16___default.a(canonicalUrl);
  var canonicalPath = canonicalURI.path(true);
  return __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, __jsx(next_head__WEBPACK_IMPORTED_MODULE_9___default.a, null, noindex.includes(canonicalPath) && __jsx("meta", {
    name: "robots",
    content: "noindex"
  }), __jsx(_components_third_party_BaiduSeoScript__WEBPACK_IMPORTED_MODULE_14__[/* BaiduSeoScript */ "a"], {
    lines: page.lines,
    locale: locale,
    userAgent: userAgent,
    originalUrl: originalUrl,
    pageTitle: pageTitle,
    pageType: pageType,
    pageDescription: pageDescription
  })), __jsx(_components_seo_FacebookAndTwitterSeoHeaderMeta__WEBPACK_IMPORTED_MODULE_13__[/* FacebookAndTwitterSeoHeaderMeta */ "a"], {
    description: pageDescription,
    lines: page.lines,
    pageType: pageType,
    title: pageTitle,
    url: currentUri.toString()
  }), __jsx("main", {
    role: "main"
  }, __jsx(Line, page.tracking), page.lines.map(function (line) {
    return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, line, {
      key: line.id,
      pageLines: page.lines
    }));
  })));
};
DynamicPage.pageId = 'DYNAMIC_PAGE';
DynamicPage.pageType = 'DYNAMIC_PAGE';

/***/ }),

/***/ "xlFl":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...dynamicPage]",
      function () {
        return __webpack_require__("LeDf");
      }
    ]);
  

/***/ })

},[["xlFl",4,1,6,0,5,7,8,20]]]);